import React from 'react';
export const Select = ({ children, ...props }) => <select {...props}>{children}</select>;
export const SelectTrigger = ({ children, ...props }) => <div {...props}>{children}</div>;
export const SelectContent = ({ children, ...props }) => <div {...props}>{children}</div>;
export const SelectItem = ({ children, ...props }) => <option {...props}>{children}</option>;
export const SelectValue = ({ placeholder }) => <span>{placeholder}</span>;
export const SelectGroup = ({ children }) => <optgroup>{children}</optgroup>;
export const SelectLabel = ({ children }) => <label>{children}</label>;
